import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Names for icons that appear identically in more than one template. This is
 * deliberately NOT a full icon library — most of the app's ~20 inline <svg>
 * blocks are each used exactly once and don't need extracting. Add a name here
 * only once the same path/polyline data is copy-pasted into a second template.
 */
export type IconName =
  | 'chevron-down'
  | 'chevron-first'
  | 'chevron-last'
  | 'chevron-left'
  | 'chevron-right'
  | 'close'
  | 'document'
  | 'download'
  | 'expand'
  | 'eye'
  | 'printer'
  | 'search'
  | 'trash';

@Component({
  selector: 'app-icon',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconComponent {
  @Input() name: IconName = 'chevron-down';
  @Input() size = 14;
  @Input() strokeWidth = 2;
}
